import AdminServicesContent from "../../../components/Admin/Services"

const AdminServices = () => {

    return (
        <>
            <AdminServicesContent />
        </>
    )

}

export default AdminServices